module.exports = "/_next/static/images/shopee-d7adf6efa66aea6b344d70230954dd90.png";